function defaultHighlighter(match) {
  const mark = document.createElement("mark")
  mark.textContent = match
  return mark
}

function wrap(value) {
  return Array.isArray(value) ? value : [value]
}

export function highlight(text, phrases, options = {}, block = null) {
  if (!text || !phrases) {
    const span = document.createElement("span")
    span.textContent = text || ""
    return span
  }

  const escapedPhrases = wrap(phrases).map((phrase) =>
    phrase instanceof RegExp
      ? phrase.source
      : phrase.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  )
  const regex = new RegExp(`(${escapedPhrases.join("|")})`, "gi")

  const highlighter = block || options.highlighter || defaultHighlighter

  const container = document.createElement("span")
  let lastIndex = 0
  let match

  while ((match = regex.exec(text)) !== null) {
    if (match.index === regex.lastIndex && match[0].length === 0) {
      regex.lastIndex++
      continue
    }

    if (match.index > lastIndex) {
      container.appendChild(
        document.createTextNode(text.substring(lastIndex, match.index))
      )
    }

    const result = highlighter(match[0])
    if (result instanceof Node) {
      container.appendChild(result)
    } else {
      container.appendChild(document.createTextNode(result))
    }

    lastIndex = regex.lastIndex
  }

  if (lastIndex < text.length) {
    container.appendChild(document.createTextNode(text.substring(lastIndex)))
  }

  return container
}
